<template>
  <div class="position-relative">
    <div class="row no-gutters mb-2">
      <div class="col-7 col-lg-8 pr-1">
        <input type="date" id="pesquisarData" class="form-control" @keyup.enter="pesquisar()"
               v-model="pesquisa.data" v-if="pesquisa.filtro === '2'" @focus="aberto = false">
        <input id="pesquisarPedido" class="form-control" type="search"
               :placeholder="pesquisa.filtro === '1' ? 'Buscar pedido ou cliente' : filtros.find(f => f.value === pesquisa.filtro).nome"
               @focus="aberto = false" :disabled="load || pesquisa.status !== '1'"
               v-model="pesquisa.data" @keyup="pesquisarTermo" @search="pesquisarTermo" v-else>
      </div>
      <div class="col-5 col-lg-4 d-flex" v-if="pesquisa.filtro === '2'">
        <div class="w-50 pr-1">
          <button :disabled="load" class="btn btn-warning btn-block" @click="pesquisar()"><i class="fa fa-search"></i></button>
        </div>
        <div class="w-50">
          <button class="btn btn-success btn-block" @click="openPesquisa" :disabled="load"><i class="fa fa-bars"></i></button>
        </div>
      </div>
      <div class="col-5 col-lg-4" v-else>
        <button :class="pesquisa.ativada ? 'btn-success' : 'btn-warning'" :disabled="load" class="btn btn-block text-nowrap" @click="openPesquisa">
          <i class="fa fa-bars mr-2"></i>
          <small>{{pesquisa.ativada ? 'Ativo' : 'Filtros'}}</small>
        </button>
      </div>
    </div>
    <div id="campoPesquisar" class="pesquisar card border shadow rounded-sm" :class="{ aberto }" tabindex="0" @blur="aberto = false" @click="aberto = false">
      <div v-if="pesquisa.ativada">
        <button class="btn btn-secondary btn-block btn-sm" @click="limparPesquisa()">Limpar pesquisa</button>
        <hr>
      </div>
      <div v-if="multiple">
        <h6 class="font-weight-bold mb-1">Empresas</h6>
        <div>
          <label><input type="radio" name="empresaPedido" value="" v-model="pesquisa.id_empresa" @change="pesquisar">
            Todas
          </label>
        </div>
        <div v-for="(e, index) in empresas" :key="index">
          <label><input type="radio" name="empresaPedido" :value="e.id_empresa" v-model="pesquisa.id_empresa" @change="pesquisar">
            {{ e.nome_fantasia }}
          </label>
        </div>
        <hr>
      </div>
      <div>
        <h6 class="font-weight-bold mb-1">Tipo do Pedido</h6>
        <div v-for="(f, index) in tipos" :key="index">
          <label><input type="radio" name="tipoPedido" :value="f.value" v-model="pesquisa.tipo_pedido" @change="filtrarTipo">
            {{ f.nome }}
          </label>
        </div>
      </div>
      <hr>
      <div>
        <h6 class="font-weight-bold mb-1">Origem do Pedido</h6>
        <div v-for="(f, index) in origins" :key="index">
          <label><input type="radio" name="origins" :value="f.value" v-model="pesquisa.origin" @change="filtrarOrigin()">
            {{ f.nome }}
          </label>
        </div>
      </div>
      <hr>
      <div>
        <h6 class="font-weight-bold mb-1">Status do Pedido</h6>
        <div v-for="f in listStatus">
          <label><input type="radio" name="status" :value="f.value" v-model="pesquisa.status" @change="filtrarStatus()">
            {{ f.nome }}
          </label>
        </div>
      </div>
      <hr>
      <div class="mb-2">
        <h6 class="font-weight-bold mb-1">Filtrar por:</h6>
        <div v-for="f in filtros">
          <label><input type="radio" name="filtros" :value="f.value" v-model="pesquisa.filtro" @change="filtrarFiltro()">
            {{ f.nome }}
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['load'],
  name: "PesquisarPedido",
  data() {
    return {
      filtros: [
        { value: '1', nome: 'Cliente ou pedido' },
        { value: '3', nome: 'Endereço do cliente' },
        { value: '2', nome: 'Data do pedido' }
      ],
      listStatus: [
        { value: '1', nome: 'Em andamento' },
        { value: '4', nome: 'Finalizados' },
        { value: '6', nome: 'Agendados' },
        { value: '5', nome: 'Cancelados' }
      ],
      origins: [
        { value: '', nome: 'Todos' },
        { value: '1', nome: 'App/Site' },
        { value: '3', nome: 'Pedido Manual' },
        { value: '4', nome: 'QR Code' },
        { value: '5', nome: 'WhatsApp' },
        { value: '8', nome: 'Tablet' }
      ],
      tipos: [
        { value: '', nome: 'Todos' },
        { value: '1', nome: 'Entregas' },
        { value: '2', nome: 'Retiradas' },
        { value: '3', nome: 'Consumir' },
      ],

      pesquisa: {
        page: 0,
        data: '',
        tipo_pedido: '',
        origin: '',
        status: '1',
        filtro: '1',
        ativada: false,
        id_empresa: ''
      },

      multiple: false,
      aberto: false
    }
  },

  methods: {
    openPesquisa() {
      this.aberto = !this.aberto;
      this.$nextTick(() => {
        if (this.aberto) {
          this.$helpers.focusElement('campoPesquisar', true);
        }
      });
    },

    fechar() {
      setTimeout(() => {
        this.aberto = false;
      }, 150);
    },

    pesquisar() {
      this.pesquisa.ativada = this.pesquisa.id_empresa !== '' || this.pesquisa.status !== '1' || this.pesquisa.origin !== '' || this.pesquisa.tipo_pedido !== '' || !!this.pesquisa.data;
      this.$emit('pesquisar', this.pesquisa);
      this.fechar();
    },

    pesquisarTermo() {
      if (this.load) {
        return;
      }

      if (!this.pesquisa.data.trim()) {
        this.limparPesquisa();

      } else {
        this.pesquisar();
      }
    },

    filtrarFiltro() {
      this.$nextTick(() => {
        this.pesquisa.data = '';
        this.$helpers.focusElement(this.pesquisa.filtro === '2' ? 'pesquisarData' : 'pesquisarPedido', true);

        if (this.pesquisa.filtro === '2' && this.pesquisa.status === '1') {
          this.pesquisa.status = '4';
          this.pesquisa.origin = '';
          this.pesquisa.data = new Date().toDateInputValue();
          this.pesquisar();
        }
      });
    },

    filtrarOrigin() {
      this.pesquisar();
    },

    filtrarStatus(st) {
      if (st) {
        this.pesquisa.status = st;
      }

      if (['1','6'].includes(this.pesquisa.status)) {
        this.pesquisa.filtro = '1';
        this.pesquisa.data = '';

      } else {
        this.pesquisa.filtro = '2';
        this.pesquisa.data = new Date().toDateInputValue();
      }

      this.pesquisar();

      this.$nextTick(() => {
        this.$helpers.focusElement(this.pesquisa.filtro === '2' ? 'pesquisarData' : 'pesquisarPedido', true);
      });
    },

    filtrarTipo() {
      this.pesquisar();
    },

    limparPesquisa() {
      this.pesquisa.id_empresa = '';
      this.pesquisa.filtro = '1';
      this.pesquisa.tipo_pedido = '';
      this.pesquisa.status = '1';
      this.pesquisa.origin = '';
      this.pesquisa.data = '';
      this.pesquisar();
    }
  },

  mounted() {
    if (this.integracoes.find(i => i.plataforma === '2')) {
      this.origins.push({ value: '6', nome: 'iFood' });
    }

    if (this.integracoes.find(i => i.plataforma === '4')) {
      this.origins.push({ value: '7', nome: 'UaiRango' });
    }

    if (this.integracoes.find(i => i.plataforma === '16')) {
      this.origins.push({ value: '10', nome: 'AiqFome' });
    }

    if (this.integracoes.find(i => i.plataforma === '18')) {
      this.origins.push({ value: '11', nome: '99Food' });
    }

    this.multiple = this.empresas.length > 1;
  },

  created() {
    this.$parent.$on('clearPesquisa', () => {
      this.pesquisa.id_empresa = '';
      this.pesquisa.tipo_pedido = '';
      this.pesquisa.filtro = '1';
      this.pesquisa.status = '1';
      this.pesquisa.origin = '';
      this.pesquisa.data = '';
      this.pesquisa.ativada = false;
    });

    this.$parent.$on('pesquisarFiltro', (pesquisa) => {
      this.pesquisa = { ...this.pesquisa, ...pesquisa };
      this.pesquisar();
    });
  },

  computed: {
    integracoes() {
      return this.$store.state.integracoes
    },

    empresas() {
      return this.$store.state.empresas
    }
  }
}
</script>

<style scoped>
.pesquisar {
  padding: 14px 12px;
  width: 222px;
  height: 322px;
  overflow-y: auto;
  position: absolute;
  top: 42px;
  right: 4px;
  z-index: 99;
  visibility: hidden;
  opacity: 0;
  transition: visibility 0.5s, opacity 0s linear;
}

.pesquisar.aberto {
  visibility: visible;
  opacity: 1;
}

.pesquisar label {
  cursor: pointer;
  margin: 6px 0 0;
  font-size: 14px;
}

.pesquisar h6 {
  font-size: 15px;
}
</style>
